module.exports = __webpack_public_path__ + "img/next-arrow.20bb295c.svg";